import React from 'react';
import { EditableTextBox, StaticTextBox } from './subcomponents';
import { EditableTextBoxProps } from './types';
import styles from './TextBoxWidget.module.scss';

export const TextBoxWidget: React.FC<
  EditableTextBoxProps & { isInEditMode: boolean }
> = ({ index, widget, isInEditMode, onExitEditMode, onUpdate }) => (
  <div className={styles.container}>
    {isInEditMode ? (
      <EditableTextBox
        widget={widget}
        index={index}
        onExitEditMode={onExitEditMode}
        onUpdate={onUpdate}
      />
    ) : (
      <StaticTextBox text={widget.value ?? ''} textAlign={widget.textAlign} />
    )}
  </div>
);
